import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=388806ac&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=388806ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388806ac",
  null
  
)

export default component.exports